<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >
    <b-card-header>
      <div>
        <b-card-title>  Top 10 Highest Value Shoppers </b-card-title>
      </div>
    </b-card-header>
    <b-card-body>
      <b-row class="mx-0">
        <b-col
            md="12"
            class="revenue-report-wrapper"
        >
          <b-table striped hover :items="customers" :fields="columns">
            <template v-slot:cell(customerName)="data">
              <a style="text-decoration: underline; font-weight: bolder;" :href="'/apps/customer/'+data.item.id+'?start_date='+start_date+'&end_date='+end_date">{{ data.value  }}</a>
            </template>
            <template v-slot:cell(totalPoints)="data">
              <a style="text-decoration: underline; font-weight: bolder;" :href="'/apps/customer/'+data.item.id+'?start_date='+start_date+'&end_date='+end_date">{{ data.value | number('0,0') }}</a>
            </template>
          </b-table>

        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import {mapActions} from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment/moment";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
    DatePicker
  },
  directives: {
    Ripple,
  },
  props: {
    start_date:{
      type: String,
      required: true
    },
    end_date:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      columns:['customerName','totalPoints'],
      startDate:'2023-07-01',
      endDate:new Date().toISOString().split('T')[0],
      transactionType:'ACCRUAL',
      customers:[]
    }
  },
  mounted (){
    this.getCustomerPerformanceData();
  },
  methods: {
    ...mapActions(["getCustomerPerformance"]),

    getCustomerPerformanceData(){
      let self = this;

      this.isLoading = true;

      let endDate = this.end_date;

      if(!endDate) {
        endDate = moment().format('YYYY-MM-DD');
      }

      this.getCustomerPerformance({startDate: this.start_date, endDate:endDate,transactionType:this.transactionType, limit: 10})
          .then(function (customers) {
            self.isLoading = false;
            self.customers = customers;

          })
          .catch(function (error) {

            self.isLoading = false;

            console.log(error)
          })
    },
  }
  }
</script>
